import React from "react";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ComputerIcon from "@material-ui/icons/Computer";
import ListIcon from "@material-ui/icons/List";
import { useSelector } from "react-redux";
import history from "./history";

const useStyles = makeStyles((theme) => ({
  // necessary for content to be below app bar
  sideBarDiv: {
    height: "70vh",
  },
  sideBarList: {
    height: "100%",
  },
}));

function LeftSideBar(props) {
  const classes = useStyles();
  const theme = useTheme();
  const authIndicator = useSelector((state) => {
    if (state.loginSuccesReducer != null)
      return state.loginSuccesReducer.data.isLoggedIn;
    else return false;
  });
  let leftMenu = null;
  if (authIndicator) {
    leftMenu = (
      <div className={classes.sideBarDiv}>
        <List className={classes.sideBarList}>
          <ListItem button key="Servers"  onClick={()=>history.push("/servers")}>
            <ListItemIcon>
              <ComputerIcon />
            </ListItemIcon>
            <ListItemText primary="Servers" />
          </ListItem>
          <ListItem button key="Services"  onClick={()=>history.push("/services")}>
            <ListItemIcon>
            <ListIcon />
            </ListItemIcon>
            <ListItemText primary="Services" />
          </ListItem>
          <ListItem button key="Server Configuration"  onClick={()=>history.push("/services")}>
          <ListItemIcon>
          <ComputerIcon />
            </ListItemIcon>
            <ListItemText primary="Server Configuration" />
          </ListItem>
          <ListItem button key="ESX Servers">
            <ListItemIcon>
            <ListIcon />
            </ListItemIcon>
            <ListItemText primary="ESX Servers" />
          </ListItem>
        </List>
        <Divider />
      </div>
    );
  }
  return leftMenu;
}

export default LeftSideBar;
